<template>
  <v-dialog v-model="vidljiv" max-width="900" scrollable content-class="kasa-a4">
    <v-card>
      <v-card-title class="naslov-kartice">
        {{ naslovDijaloga }}
        <span class="dodatak" v-if="broj">{{ broj }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="zatvori"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pa-0" style="height:70vh">
        <div v-if="gradim" class="cekaj">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <span>Pripremam račun…</span>
        </div>
        <div v-if="greska" class="cekaj greska">{{ greska }}</div>
        <!-- PDF se prikazuje OVDJE, a ne u skocnom prozoru: preglednik skocni
             prozor blokira cim poziv ne dode ravno iz klika, a ovdje dolazi tek
             nakon spremanja i fiskalizacije. Kupac zbog toga ne smije ostati
             bez racuna. -->
        <iframe v-if="izvor" :src="izvor" class="list"></iframe>
      </v-card-text>

      <v-card-actions>
        <v-btn text color="primary" class="text-none" :disabled="!izvor" @click="ispisi">
          <v-icon small left>mdi-printer</v-icon>Ispiši
        </v-btn>
        <v-btn text color="primary" class="text-none" :disabled="!izvor" @click="spremi">
          <v-icon small left>mdi-download</v-icon>Spremi PDF
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="zatvori">Zatvori</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { pdfA4 } from '@/snippets/kasaA4'

export default {
  name: 'kasaa4pregled',
  data () {
    return {
      vidljiv: false,
      gradim: false,
      izvor: '',
      greska: '',
      broj: '',
      naslovDijaloga: 'A4 račun'
    }
  },

  watch: {
    vidljiv (otvoren) {
      if (!otvoren) { this.pospremi() }
    }
  },

  beforeDestroy () {
    this.pospremi()
  },

  methods: {
    /**
     * @param {Object} podaci  isti objekt koji ide i na traku, s blokom "a4"
     */
    async prikazi (podaci) {
      this.pospremi()
      this.naslovDijaloga = 'A4 račun'
      this.broj = (podaci && podaci.number) || ''
      this.greska = ''
      this.gradim = true
      this.vidljiv = true
      try {
        this.izvor = await pdfA4(podaci)
      } catch (err) {
        this.greska = 'A4 račun se ne može pripremiti: ' + (err.message || err)
      } finally {
        this.gradim = false
      }
    },

    /**
     * Prikazi vec napravljen PDF. Koristi obracun, koji svoj PDF gradi sam.
     * @param {string} izvor   blob URL
     * @param {string} naslov
     */
    prikaziIzvor (izvor, naslov) {
      this.pospremi()
      this.naslovDijaloga = 'Obračun kase'
      this.broj = naslov || ''
      this.greska = ''
      this.gradim = false
      this.izvor = izvor
      this.vidljiv = true
    },

    ispisi () {
      const okvir = this.$el.querySelector('iframe')
      if (!okvir) { return }
      try {
        okvir.contentWindow.focus()
        okvir.contentWindow.print()
      } catch (e) {
        // Neki preglednici ne daju ispis iz okvira - tada ostaje "Spremi PDF".
        this.greska = 'Ispis iz pregleda nije dopušten. Spremite PDF pa ga ispišite.'
      }
    },

    spremi () {
      const a = document.createElement('a')
      a.href = this.izvor
      a.download = (this.naslovDijaloga === 'Obračun kase' ? 'obracun-' : 'racun-') +
        String(this.broj).replace(/[\/\s.–]+/g, '-') + '.pdf'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },

    // Blob ostaje u memoriji dok se izricito ne otpusti.
    pospremi () {
      if (this.izvor) {
        try { window.URL.revokeObjectURL(this.izvor) } catch (e) { /* vec otpusten */ }
        this.izvor = ''
      }
    },

    zatvori () {
      this.vidljiv = false
    }
  }
}
</script>

<style scoped>
.kasa-a4 .list { width: 100%; height: 100%; border: 0; }
.kasa-a4 .cekaj {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #607d8b;
}
.kasa-a4 .cekaj.greska { color: #c62828; padding: 0 24px; text-align: center; }
.kasa-a4 .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 14px;
  min-height: 0;
}
.kasa-a4 .naslov-kartice .dodatak {
  font-weight: 400;
  font-size: 13px;
  color: #6b8299;
  margin-left: 8px;
}
</style>
